/* =========================================================
   3) Slideshow full-height “smart” (ENTERPRISE - hardened)
   Output CSS vars:
     --dh-ann-h
     --dh-header-h
     --dh-top-offset-normal  (ann + header)
     --dh-top-offset-overlay (ann only)
     --dh-top-offset         (compat = normal)
   Also:
     html.dh-home flag
   ========================================================= */
(function () {
  if (window.__dhHeroOffsetInit) return;
  window.__dhHeroOffsetInit = true;

  function isHome() {
    try {
      return (window.location && window.location.pathname === "/") ||
             (document.body && document.body.classList.contains("template-index"));
    } catch (e) {
      return false;
    }
  }

  function hasHomepageSlideshow() {
    try {
      return !!document.querySelector("#MainContent slideshow-component");
    } catch (e) {
      return false;
    }
  }

  function isVisible(el) {
    if (!el) return false;
    if (!(el instanceof Element)) return false;
    if (el.getClientRects && el.getClientRects().length === 0) return false;
    var style = window.getComputedStyle(el);
    return style.display !== "none" && style.visibility !== "hidden" && el.offsetHeight > 0;
  }

  function pickFirst(selectors) {
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) return el;
    }
    return null;
  }

  function calcHeightsPx() {
    var announcementEl = pickFirst([
      "#shopify-section-announcement-bar",
      ".announcement-bar",
      ".utility-bar",
      ".announcement-bar-section",
    ]);

    var headerEl = pickFirst([
      "#shopify-section-header",
      ".header-wrapper",
      "sticky-header",
      "header.header",
      "header.section-header",
      ".section-header",
    ]);

    var annH = isVisible(announcementEl) ? announcementEl.offsetHeight : 0;
    var headH = isVisible(headerEl) ? headerEl.offsetHeight : 0;

    return {
      ann: annH,
      header: headH,
      normal: annH + headH,
      overlay: annH, // in overlay sottrai SOLO announcement
    };
  }

  function getViewportHeightPx() {
    try {
      if (window.visualViewport && typeof window.visualViewport.height === "number") {
        return Math.round(window.visualViewport.height);
      }
    } catch (e) {}
    return Math.round(window.innerHeight || 0);
  }

  function applyOffset() {
    if (!isHome()) return;

    // flag home sempre (il tuo body non ha template-index)
    document.documentElement.classList.add("dh-home");

    if (!hasHomepageSlideshow()) return;

    var h = calcHeightsPx();

    document.documentElement.style.setProperty("--dh-ann-h", h.ann + "px");
    document.documentElement.style.setProperty("--dh-header-h", h.header + "px");

    document.documentElement.style.setProperty("--dh-top-offset-normal", h.normal + "px");
    document.documentElement.style.setProperty("--dh-top-offset-overlay", h.overlay + "px");

    // compat (rimane normal)
    document.documentElement.style.setProperty("--dh-top-offset", h.normal + "px");

    var vv = getViewportHeightPx();
    document.documentElement.style.setProperty("--dh-vv-height", vv + "px");
  }

  var t = null;
  function applyOffsetDebounced() {
    if (t) clearTimeout(t);
    t = setTimeout(function () {
      applyOffset();
      t = null;
    }, 80);
  }

  function init() {
    applyOffset();

    window.addEventListener("resize", applyOffsetDebounced, { passive: true });
    window.addEventListener("orientationchange", applyOffsetDebounced, { passive: true });

    document.addEventListener("shopify:section:load", applyOffsetDebounced);
    document.addEventListener("shopify:section:reorder", applyOffsetDebounced);
    document.addEventListener("shopify:section:select", applyOffsetDebounced);

    try {
      if (window.visualViewport) {
        window.visualViewport.addEventListener("resize", applyOffsetDebounced, { passive: true });
        window.visualViewport.addEventListener("scroll", applyOffsetDebounced, { passive: true });
      }
    } catch (e) {}

    try {
      var headerObsTarget = pickFirst([
        "#shopify-section-header",
        ".header-wrapper",
        "sticky-header",
        "header.header",
      ]);

      var annObsTarget = pickFirst([
        "#shopify-section-announcement-bar",
        ".announcement-bar",
        ".utility-bar",
      ]);

      if (window.ResizeObserver) {
        var ro = new ResizeObserver(function () {
          applyOffsetDebounced();
        });
        if (headerObsTarget instanceof Element) ro.observe(headerObsTarget);
        if (annObsTarget instanceof Element) ro.observe(annObsTarget);
      }
    } catch (e) {}
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  window.addEventListener("load", function () {
    applyOffsetDebounced();
    setTimeout(applyOffsetDebounced, 150);
    setTimeout(applyOffsetDebounced, 450);
  });
})();



/* =========================================================
   4) Header overlay trasparente (DESKTOP + HOME)
   - Trasparente SOLO nella prima metà dello slideshow
   - HARDENED: aspetta che slideshow-component esista davvero
   ========================================================= */
(function () {
  if (window.__dhHeaderOverlayInit) return;
  window.__dhHeaderOverlayInit = true;

  var mql = window.matchMedia("(min-width: 750px)");
  var heroEl = null;
  var threshold = 0;
  var ticking = false;
  var mo = null;
  var ro = null;

  function isHome() {
    try {
      return (window.location && window.location.pathname === "/") ||
             (document.documentElement && document.documentElement.classList.contains("dh-home"));
    } catch (e) {
      return false;
    }
  }

  function shouldRun() {
    return mql.matches && isHome();
  }

  function findHero() {
    return document.querySelector("#MainContent slideshow-component");
  }

  function computeThresholdPx() {
    var h = 0;
    try {
      if (heroEl && heroEl.offsetHeight) h = heroEl.offsetHeight;
    } catch (e) {}

    if (!h || h < 200) {
      try { h = Math.round(window.innerHeight || 0); } catch (e2) { h = 0; }
    }
    return Math.round(h * 0.5);
  }

  function recalc() {
    heroEl = findHero();
    threshold = heroEl ? computeThresholdPx() : 0;

    // ResizeObserver sul hero per ricalcolare se Dawn cambia height (lazy media)
    try {
      if (ro) ro.disconnect();
      if (window.ResizeObserver && heroEl instanceof Element) {
        ro = new ResizeObserver(function () {
          threshold = computeThresholdPx();
          apply();
        });
        ro.observe(heroEl);
      }
    } catch (e) {}
  }

  function apply() {
    // sempre pulizia
    document.documentElement.classList.remove("dh-header-overlay");

    if (!shouldRun()) return;
    if (!heroEl || threshold <= 0) return;

    var y = window.scrollY || window.pageYOffset || 0;
    if (y < threshold) document.documentElement.classList.add("dh-header-overlay");
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      apply();
    });
  }

  function ensureHeroThenRun() {
    recalc();
    apply();

    if (heroEl) {
      if (mo) { try { mo.disconnect(); } catch (e) {} }
      mo = null;
      return;
    }

    // aspetta che Dawn inserisca/idrati slideshow-component
    try {
      if (mo) mo.disconnect();
      mo = new MutationObserver(function () {
        var h = findHero();
        if (h) {
          heroEl = h;
          threshold = computeThresholdPx();
          apply();
          try { mo.disconnect(); } catch (e) {}
          mo = null;
        }
      });

      var target = document.querySelector("#MainContent") || document.body;
      mo.observe(target, { childList: true, subtree: true });
    } catch (e) {}
  }

  function init() {
    ensureHeroThenRun();

    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", function () {
      ensureHeroThenRun();
    }, { passive: true });

    document.addEventListener("shopify:section:load", function () {
      ensureHeroThenRun();
      setTimeout(ensureHeroThenRun, 150);
      setTimeout(ensureHeroThenRun, 450);
    });

    window.addEventListener("load", function () {
      ensureHeroThenRun();
      setTimeout(ensureHeroThenRun, 150);
      setTimeout(ensureHeroThenRun, 450);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  if (mql.addEventListener) {
    mql.addEventListener("change", function () {
      ensureHeroThenRun();
    });
  } else if (mql.addListener) {
    mql.addListener(function () {
      ensureHeroThenRun();
    });
  }
})();
